import { ActionTypes } from 'redux/utils/Send'

export default ActionTypes('IR_CONVERSATION_JOIN_INTENT')